import React from "react";
import { CatalogItemsList } from "./CatalogItemsList";

export const CatalogItemsPage: React.FC = () => <CatalogItemsList />;
